<template>
  <v-container>
    <v-sheet height="32px">
      <v-toolbar flat color="white" height="30px" outlined>
        <v-toolbar-title small>{{ $t('title.history') }}</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
    </v-sheet>

    <v-row>
      <v-col cols="12">
        <v-autocomplete
          :items="menuList"
          v-model="name"
          item-text="name"
          :label="$t('label.menu_name')"
          :no-data-text="$t('msg.no-data-text')"
          :full-height="true"
          hide-no-data
          hide-selected
          return-object
          prepend-icon="search"
        ></v-autocomplete>
      </v-col>
    </v-row>
    <div v-if="historyItems.length">
      <div class="pa-4">
        <v-card v-for="(item, i) in historyItems" :key="i" @click="openMenu(item)" outlined tile>
          <div class="menu-list-row">
            <div class="pa-2 d-flex justify-center">
              <div class="ma-1">
                <div class="text-center">{{ item.start }}</div>
              </div>
              <div class="ma-1">
                <div class="text-center">～</div>
              </div>
              <div class="ma-1">
                <div class="text-center">{{ item.end }}</div>
              </div>
            </div>
            <div class="pl-2 pr-2">
              <div class="d-block">
                <div class="pl-2 pr-2 text-center">
                  <div :class="['pa-1', 'font-weight-bold', item.hasAllergy === true ? 'has-allergy' : '' ]">
                    {{ item.name }}
                  </div>
                </div>
              </div>
              <div class="d-block">
                <div class="pa-2 menu-nutrient">
                  <div class="d-flex justify-space-around" outlined tile>
                    <div v-for="(nutrientId, key) in item.nutrients" :key="key" class="mr-5">
                      <img v-bind:src="$nutrients.getIcon(nutrientId)" class="nutrients-icon">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </v-card>
      </div>
    </div>
    <div v-else>
      <div class="pa-4">
        <p>{{ $t('msg.empty-history') }}</p>
      </div>
    </div>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    menuList: [],
    historyItems: [],
    name: ''
  }),
  computed: {
  },
  watch: {
    name: function (item) {
      if ((typeof item) !== 'object') {
        this.updateList()
        return
      }

      const historyItems = [];

      this.menuList.forEach((_, idx) => {
        if (-1 < this.menuList[idx].name.indexOf(item.name)) {
          historyItems.push(this.menuList[idx])
        }
      })
      // 降順にする
      historyItems.sort(function (a, b) {
        if (a.start < b.start) {
          return 1
        } else {
          return -1
        }
      })
      this.historyItems = historyItems;
    }
  },
  mounted() {
    const babyData = this.$storage.getBabyData()
    if (babyData === null) {
      this.$router.push({ name: 'Config' })
      return
    }
    const menuList = this.$storage.getAllMenu();
    this.menuList = menuList;
    this.updateList()
  },
  methods: {
    updateList () {
      const historyItems = [];
      this.menuList.forEach((item, idx) => {
        historyItems.push(this.menuList[idx])
      })
      // 降順にする
      historyItems.sort(function (a, b) {
        if (a.start < b.start) {
          return 1
        } else {
          return -1
        }
      })
      this.historyItems = historyItems;
    },
    openMenu (item) {
      // Safari対応
      const itemDate = Date.parse(item.start.replace(/-/g , '/'))
      if (itemDate !== null) {
        this.$storage.setFocusDate(parseInt(itemDate))
        this.$router.push({ name: 'Menu', params: { id: item.hash } })
      }
    }
  }
};
</script>
